import { render, staticRenderFns } from "./district.vue?vue&type=template&id=2b2a492a&"
import script from "./district.vue?vue&type=script&lang=js&"
export * from "./district.vue?vue&type=script&lang=js&"
import style0 from "./district.vue?vue&type=style&index=0&id=2b2a492a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports